export class NewLoginEntity {
    public userName=''
    public password=''
    public smsCode=''
    public version=''
    public reqFlag=''
}
